import { formatExportTimestamp } from "helpers/dates";
import { sanitizeFilename } from "helpers/filenames";

export const EXPORT_FALLBACK_FILENAME = "Lighthouse-Storage-Export.xlsx";

export const buildExportFilename = (reportType: string, date = new Date()) => {
  const resolvedReportType = reportType.trim();

  if (!resolvedReportType) {
    return EXPORT_FALLBACK_FILENAME;
  }

  const timestamp = formatExportTimestamp(date);

  return sanitizeFilename(
    `Lighthouse-Storage-${resolvedReportType}-${timestamp}.xlsx`,
    EXPORT_FALLBACK_FILENAME,
  );
};
